// extracted by mini-css-extract-plugin
module.exports = {"c-footer":"_84ff5fbbc9--c-footer--ciSl5","c-footer-mobile":"_84ff5fbbc9--c-footer-mobile--3XFKO","c-footer-adaptive":"_84ff5fbbc9--c-footer-adaptive--3BwBB"};